import Backbone from 'backbone'
import unwrapModel from 'scoreboard/components/unwrap-model'
import spectator from 'scoreboard/components/spectator'
import conductor from 'scoreboard/components/conductor'

const StatefulView = Backbone.View.extend({

	/**
	 * Used to recreate the current UI state for bookmarks, briefings, and exports
	 * @param {Boolean} options.isWob If the state is for a report inside a dashboard wob
	 * @param {Boolean} options.export If the state is for na export
	 */
	getState: function (options={}) {
		let state = {}
		// Only a report's sort can be modified when spectating
		const spectating = spectator.spectates(conductor.section())
		// If we're exporting a modified report we need the entire model
		if (!spectating && !options.isWob && options.export) {
			const attributes = unwrapModel(this.model)
			// Invoked by send-to-export.js, this is what get's POSTed and
			// saved in the exports table
			if (this.model.isNew() || attributes.dirty) { // If no unsaved changes, don't persist the state
				state = attributes
			}
		} else { // Otherwise, the only mutable state is the sort
			let sortState = this.getSortState()
			if (sortState) {
				state.sort = sortState
			}
		}
		return state
	},

	getSortState: function () {
		if (!this.sortableTable) {
			return null
		}

		let sortState = this.sortableTable.state()

		// For reports with multiple periods of data that are sorting by period data
		// (like `score`), keep track of which period column's data should be used
		sortState.sortPeriodIndex = sortState.periodVar

		return sortState
	}
})

export default StatefulView

StatefulView.__filename__ = 'reports/common/stateful-view.js'
